module.exports = __webpack_public_path__ + "img/LogoOriginalSVE.057e986f.png";